// src/firebase/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyDRFIJWJ4crpqWBU2VWFrIAUfPO6L60E7g', // your key (unchanged)
  authDomain: 'elevateevent.co',
  projectId: 'scan-cap',
   messagingSenderId: "905360070878",
  appId: "1:905360070878:web:b900da590644067cdb8a4f",
  storageBucket: 'scan-cap.appspot.com',
};

export const app = initializeApp(firebaseConfig);

// ---- App Check: run exactly once ----
if (typeof window !== 'undefined') {
  if (!window.__EES_APP_CHECK_INIT__) {
    // enable debug token in dev BEFORE initializeAppCheck
    if (process.env.NODE_ENV === 'development') {
      self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }

    // IMPORTANT: replace with your REAL App Check reCAPTCHA v3 **site key**
    // Find it in Firebase Console → App Check → your Web app
    const SITE_KEY = '6LdKVtkrAAAAADIEmkGVtJjmfnN6hqqSgrM6pc8v';

    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(SITE_KEY),
      isTokenAutoRefreshEnabled: true,
    });

    window.__EES_APP_CHECK_INIT__ = true;
  }
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
